import axios from "../../axios.js";
import { multiPartData } from "src/helpers/index.js";

const addHotel = async (Payload) => {
  const formData = multiPartData(Payload);
  const res = await axios.post("hotel/add", formData);
  return res.data;
};

// ** Function to get all Upcoming Courses
const getHotels = async (params) => {
  const res = await axios.get(
    `/hotel/all?search=${params.search}&limit=${params.limit}&sort=${params.sort}&page=${params.page}&filter=${params.filter}&status=${params.status}`,
  );

  return res?.data;
};

const getHotelsWithoutWarden = async () => {
  const res = await axios.get("/hotel/without-warden");
  return res?.data?.data;
}

const getHotelDetailsById = async (hotelId) => {
  const res = await axios.get(`/hotel/details/${hotelId}`);
  return res?.data;
};

const getHotelRoomsList = async (filter) => {
  const { hotelId, id } = filter;
  const res = await axios.get(`/hotel/rooms/list/${hotelId}/${id}`);
  return res?.data;
};

const updateHotel = async (Payload) => {
  const formData = multiPartData(Payload);
  const res = await axios.post("hotel/update", formData);
  return res.data;
};

const updateHotelRoom = async (payload) => {
  const res = await axios.post("hotel/room/update", payload);
  return res.data;
};

const deleteHotelById = async (hotelId) => {
  const res = await axios.delete(`/hotel/delete/${hotelId}`);
  return res?.data;
};

const deleteRoomType = async (hotelId, roomDetailId) => {
  const res = await axios.delete(`/hotel/${hotelId}/${roomDetailId}`)
  return res?.data;
}

const activateDeactivateAccount = async (Payload) => {
  const res = await axios.post("hotel/hotelStatus", Payload);
  return res.data;
};

const getAvailableRoomByHid = async (payload) => {
  const res = await axios.post(`/hotel/rooms/available`, payload);
  return res?.data;
};

const getRoomsByHostelId = async (payload) => {
  try {
    // Backend requires hotelId in the body for this POST route

    const res = await axios.post(`/hotel/rooms/available`, payload);

    // Response check
    if (res.data && Array.isArray(res.data)) {
      return res.data;
    } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
      return res.data.data;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching rooms:", error);
    return [];
  }
};

//  const updateWardenProfile = async (id, formData) => {
//   try {
//     // Yeh Warden ke liye specific PUT request bhejega
//     const response = await axios.put(`/hotel/update/${id}`, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

const updateWardenProfile = async (id, payload) => {
  const dataToSend = (payload instanceof FormData) ? payload : multiPartData(payload);


  // Agar aapne backend me route '/warden/hostel/update' banaya hai to wo use karein
  // Agar aap purana route use kar rhe hain, to make sure Backend usse allow kare

  // Option A (Recommended - New Route):
  const res = await axios.post(`hotel/warden/hostel/update`, dataToSend);

  // Option B (If using ID in URL):
  // const res = await axios.put(`/hotel/update/${id}`, dataToSend);

  return res.data;
};



export {
  addHotel,
  getHotels,
  getHotelDetailsById,
  updateHotel,
  deleteHotelById,
  activateDeactivateAccount,
  getHotelRoomsList,
  updateHotelRoom,
  getAvailableRoomByHid,
  getRoomsByHostelId,
  updateWardenProfile,
  deleteRoomType,
  getHotelsWithoutWarden
};
